import React, { useEffect, useRef, useState } from 'react';
import mqtt, { Client } from 'mqtt';
import useStorage from './useStorage';

const mqttOptions = {
  port: 9883,
  path: '/mqtt',
  clean: true,
  reconnect: true,
  reconnectPeriod: 1000,
};

function getTopic(operator = '+') {
  return [`${operator}/ruter/+/pe/sla/displays/v1`];
}

export default function useMQTT() {
  const client = useRef<Client | undefined>(undefined);
  const [connected, setConnected] = useState<boolean>(false);
  const [messages, setMessages] = useState<Record<string, Status.Item>>({});
  const [paused, setPaused] = useState<boolean>(false);
  const [pauseMessages, setPauseMessages] = useState<Record<string, Status.Item>>({});
  const { isLoaded, env, host, user, password, operator } = useStorage();

  useEffect(() => {
    if (!isLoaded) {
      return;
    }
    const topics = getTopic(operator);

    if (client && client.current) {
      console.log('Closing connection, something changed');
      // close current client
      client.current.unsubscribe(topics);
      client.current.end();
      client.current = undefined;
    }
    console.log('Opening connection');
    client.current = mqtt.connect(`wss://${host}`, {
      ...mqttOptions,
      username: user,
      password: password,
    });

    client.current.on('connect', function () {
      if (client && client.current) {
        setConnected(true);
        client.current.subscribe(topics, function (err) {
          if (err) {
            console.error(err);
          }
        });
      }
    });
    client.current.on('message', onMessage);

    return () => {
      if (client && client.current) {
        console.log('Closing connection');
        // close current client
        client.current.unsubscribe(topics);
        client.current.end();
        client.current = undefined;
      }
    };
  }, [env, host, user, password, operator, isLoaded]);

  useEffect(() => {
    if (!paused) {
      console.log(`Unpause, add ${Object.keys(pauseMessages).length}`);
      setMessages((messages) => ({
        ...messages,
        ...pauseMessages,
      }));
      setPauseMessages({});
    }
  }, [paused]);

  function onMessage(topic: string, message: string) {
    if (paused) {
      setPauseMessages((pauseMessages) => ({
        ...pauseMessages,
        [topic]: JSON.parse(message),
      }));
    } else {
      setMessages((messages) => ({
        ...messages,
        [topic]: JSON.parse(message),
      }));
    }
  }

  return {
    connected,
    messages,
    paused,
    setPaused,
  };
}
